import axios from "axios";

export default class AjaxRequest {
    constructor(url, data = {}, responseType = 'json') {
        this.url = url;
        this.data = data;
        this.responseType = responseType;
        this.output = [];
    }

    async getRequest() {
        const self = this;

        await axios.get(this.url, { params: this.data, responseType: this.responseType }).then(function (response) {
            return response;
        }).catch(function(error) {
            if(error.response) {
                // console.log('Ajax response error:', error.response);
                return error.response;
            } else if (error.request) {
                // console.log('Ajax request error:', error.request);
                return error.request;
            } else {
                // console.log('Some other error occured during your get request', error.message);
                return error.message;
            }
        }).then(function(data) {
            // TODO: comment out when in production
            // console.log('Get Request:', data);
            self.output = data;
        });

        return this.output;
    }

    async postRequest() {
        const self = this;
        await axios.post(this.url, this.data).then(function (response) {
            return response;
        }).catch(function (error) {
            if(error.response) {
                // console.log('Ajax response error:', error.response);
                return error.response;
            } else if (error.request) {
                // console.log('Ajax request error:', error.request);
                return error.request;
            } else {
                // console.log('Some other error occured during your get request', error.message);
                return error.message;
            }
        }).then(function (data) {
            // TODO: comment out when in production
            // console.log(data);
            self.output = data;
        });

        return this.output;
    }

    async patchRequest() {
        const self = this;
        await axios.patch(this.url, this.data).then(function (response) {
            return response;
        }).catch(function (error) {
            if (error.response) {
                // console.log('Ajax response error:', error.response);
                return error.response;
            } else if (error.request) {
                // console.log('Ajax request error:', error.request);
                return error.request;
            } else {
                // console.log('Some other error occured during your get request', error.message);
                return error.message;
            }
        }).then(function (data) {
            // TODO: comment out when in production
            // console.log(data);
            self.output = data;
        });

        return this.output;
    }

    async deleteRequest() {
        const self = this;
        await axios.delete(this.url, this.data).then(function (response) {
            return response;
        }).catch(function (error) {
            if (error.response) {
                // console.log('Ajax response error:', error.response);
                return error.response;
            } else if (error.request) {
                // console.log('Ajax request error:', error.request);
                return error.request;
            } else {
                // console.log('Some other error occured during your get request', error.message);
                return error.message;
            }
        }).then(function (data) {
            // TODO: comment out when in production
            self.output = data;
        });

        return this.output;
    }
}
